import { Link, Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { auth } from './lib/api';
import { LoginPage } from './pages/LoginPage';
import { JobsListPage } from './pages/JobsListPage';
import { JobNewPage } from './pages/JobNewPage';
import { JobDetailPage } from './pages/JobDetailPage';
import { JobEditPage } from './pages/JobEditPage';
import { ApplicationDetailPage } from './pages/ApplicationDetailPage';
import { ApplyPage } from './pages/ApplyPage';

function AdminLayout() {
  const navigate = useNavigate();
  if (!auth.isLoggedIn) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen">
      <header className="border-b border-ink-700 bg-ink-950/70 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3">
          <Link to="/" className="text-sm font-bold tracking-widest text-slate-100">
            ETNRLZ <span className="text-brand-400">JOBS</span>
          </Link>
          <button
            className="text-xs text-slate-400 hover:text-slate-200"
            onClick={() => {
              auth.clear();
              navigate('/login');
            }}
          >
            Sair
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/v/:slug" element={<ApplyPage />} />
      <Route element={<AdminLayout />}>
        <Route path="/" element={<JobsListPage />} />
        <Route path="/vagas/nova" element={<JobNewPage />} />
        <Route path="/vagas/:id" element={<JobDetailPage />} />
        <Route path="/vagas/:id/editar" element={<JobEditPage />} />
        <Route path="/vagas/:id/candidatos/:appId" element={<ApplicationDetailPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
